import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import './index.css';
import App from './App';
import appFavicon from './images/TTG-snail.png';
import axios from 'axios';
import { loadErrorMessages, loadDevMessages } from "@apollo/client/dev";
import {
  ApolloClient,
  InMemoryCache,
  HttpLink,
  ApolloProvider,
  split
} from "@apollo/client";
import { Provider } from 'react-redux';
import store from './store/store';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { createClient } from 'graphql-ws';
import { getMainDefinition } from '@apollo/client/utilities';
import { SnackbarProvider } from 'notistack';
import keycloak from './keycloak';

axios.defaults.withCredentials = true;

if (typeof document !== "undefined") {
  const iconRels = ["icon", "shortcut icon", "apple-touch-icon"];
  iconRels.forEach((rel) => {
    let icon = document.querySelector(`link[rel='${rel}']`);
    if (!icon) {
      icon = document.createElement("link");
      icon.rel = rel;
      document.head.appendChild(icon);
    }
    icon.type = "image/png";
    icon.href = appFavicon;
  });
}

if (true) {  // Adds messages only in a dev environment
  loadDevMessages();
  loadErrorMessages();
}

const DASHBOARD_REDIRECT_URI = typeof window !== 'undefined' ? `${window.location.origin}/` : undefined;

// Initialize Keycloak
keycloak.init({
  onLoad: 'login-required',
  pkceMethod: 'S256',
  checkLoginIframe: false,
}).then((authenticated) => {
  console.log('Keycloak initialized. Authenticated:', authenticated);

  //Refresh Keycloak token continuously
  setInterval(() => {
    keycloak.updateToken(30).catch(() => keycloak.login({ redirectUri: DASHBOARD_REDIRECT_URI }));
  }, 10000);

  const isProd = process.env.NODE_ENV === 'production';
  console.log("isProd : ", isProd);
  const defaultHttp = isProd ? '/api/graphql' : 'http://localhost:8000/graphql';
  const defaultWs = isProd
    ? (typeof window !== 'undefined' ? `${window.location.origin.replace(/^http/, 'ws')}/api/graphql` : 'ws://localhost/api/graphql')
    : 'ws://localhost:8000/graphql';
  const GRAPHQL_HTTP_URL = process.env.REACT_APP_GRAPHQL_HTTP_URL || defaultHttp;
  const GRAPHQL_WS_URL = process.env.REACT_APP_GRAPHQL_WS_URL || defaultWs;

  const httpLink = new HttpLink({
    uri: GRAPHQL_HTTP_URL,
    credentials: "include",
    headers: {
      authorization: keycloak.token ? `Bearer ${keycloak.token}` : "",
    },
    fetch: async (uri, options) => {
      // Refresh token if needed before making request
      if (keycloak.isTokenExpired()) {
        await keycloak.updateToken(5);
      }
      if (options.headers) {
        options.headers.authorization = `Bearer ${keycloak.token}`;
      }
      return fetch(uri, options);
    },
  });

  const wsLink = new GraphQLWsLink(createClient({
    url: GRAPHQL_WS_URL,
    connectionParams: async () => {
      if (keycloak.isTokenExpired()) {
        await keycloak.updateToken(5);
      }
      return {
        authorization: keycloak.token ? `Bearer ${keycloak.token}` : "",
      };
    },
  }));

  const splitLink = split(
    ({ query }) => {
      const definition = getMainDefinition(query);
      return (
        definition.kind === 'OperationDefinition' &&
        definition.operation === 'subscription'
      );
    },
    wsLink,
    httpLink,
  );

  const client = new ApolloClient({
    link: splitLink,
    cache: new InMemoryCache(),
  });

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <ApolloProvider client={client}>
          <BrowserRouter>
            <SnackbarProvider maxSnack={3} anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
              <App />
            </SnackbarProvider>
          </BrowserRouter>
        </ApolloProvider>
      </Provider>
    </React.StrictMode>
  );
}).catch((error) => {
  console.error('Keycloak initialization failed:', error);
  ReactDOM.createRoot(document.getElementById('root')).render(
    <div>Error initializing authentication. Please refresh the page.</div>
  );
});
